import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ABCDE from './ABCDE';
import OutputWeergave from './OutputWeergave';
import styles from './Beoordeling.module.css';

export default function Beoordeling() {
  const [fase, setFase]           = useState('invoer');    // 'invoer' | 'genereren' | 'output'
  const [abcdeData, setAbcdeData] = useState(null);
  const [outputData, setOutputData] = useState(null);
  const [laden, setLaden]         = useState(false);

  async function handleOutputGenereren(data) {
    setAbcdeData(data);
    setFase('genereren');
    setLaden(true);

    try {
      const res = await axios.post('/api/outputs', {
        sessie_id:              data.sessie_id,
        output_type:            data.output_type,
        invoer:                 data.invoer,
        urgentie:               data.urgentie,
        verzoek:                data.verzoek,
        combinatieWaarschuwingen: data.combinatieWaarschuwingen,
      });

      setOutputData(res.data);
      setFase('output');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Genereren mislukt. Probeer opnieuw.');
      setFase('invoer');
    } finally {
      setLaden(false);
    }
  }

  async function handleTweedeOutput(tweedeType) {
    if (!abcdeData) return;
    try {
      const res = await axios.post('/api/outputs', {
        sessie_id:              abcdeData.sessie_id,
        output_type:            tweedeType,
        invoer:                 abcdeData.invoer,
        urgentie:               abcdeData.urgentie,
        verzoek:                abcdeData.verzoek,
        combinatieWaarschuwingen: abcdeData.combinatieWaarschuwingen,
      });
      setOutputData(res.data);
      toast.success('Tweede output gegenereerd.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Genereren mislukt.');
      throw err;
    }
  }

  function handleNieuweBeoordeling() {
    setFase('invoer');
    setAbcdeData(null);
    setOutputData(null);
  }

  return (
    <div className={styles.pagina}>
      {fase === 'invoer' && (
        <ABCDE onOutputGenereren={handleOutputGenereren} />
      )}

      {fase === 'genereren' && (
        <div className={styles.genereren}>
          <div className={styles.laadindicator}>
            <div className={styles.pulseRing}><div className={styles.dot}></div></div>
            <p className={styles.laadTekst}>Output wordt opgesteld...</p>
            <small className={styles.laadSub}>AI stelt de rapportage voor u samen</small>
          </div>
        </div>
      )}

      {fase === 'output' && outputData && (
        <OutputWeergave
          outputData={outputData}
          sessieId={abcdeData?.sessie_id}
          onNieuweBeoordeling={handleNieuweBeoordeling}
          onTweedeOutput={handleTweedeOutput}
        />
      )}
    </div>
  );
}
